import React from "react";
import { useNavigate } from "react-router-dom";

import { useMediaQuery } from "@mui/material";

import { Container } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";

import ResultColours from "../results/services/ResultColours";
import { animals } from "../results/services/ResultAnimals";
import { QUIZ_LENGTH } from "../..";
import { CustomGrid, classes } from "./style";

export const AnimalsScene = () => {
  const navigate = useNavigate();

  const { colours_main } = ResultColours();

  const takeQuiz = async () => {
    navigate({
      pathname: "/quiz",
    });

    sessionStorage.setItem("answers", "0".repeat(QUIZ_LENGTH));
    window.location.reload();
  };

  const isMobile = useMediaQuery(
    `(max-width:${localStorage.getItem("SM_SCREEN")})`
  );

  return (
    <CustomGrid
      container
      direction="column"
      alignItems="center"
      justifyContent="flex-start"
      className={classes.root}
    >
      <Container>
        <Grid container className={classes.heading}>
          <Typography
            variant={isMobile ? "h3" : "h2"}
            className={classes.title}
          >
            Meet The Animals
          </Typography>
        </Grid>
        <Grid container className={classes.subheading}>
          <Typography variant="body1">
            The Holland Codes, also known as the RIASEC model, are a framework
            for understanding your interests and how they align with different
            career paths. Each of the six personality types represents unique
            strengths and preferences. By mapping your results to an animal, we
            provide a fun and relatable way to visualize your personality type
            and explore careers that suit your interests.
            <span className={classes.takeQuizButton} onClick={takeQuiz}>
              Take the quiz
            </span>
          </Typography>
        </Grid>
        <Grid container className={classes.animals}>
          {Object.entries(animals).map(([animal, details]) => (
            <Grid
              size={{ xs: 12, md: 6, lg: 4 }}
              className={classes.container}
              key={animal}
            >
              <div
                className={classes.animalBackground}
                style={{
                  background: colours_main[details.name.split(" ")[0]].colour,
                }}
              >
                <div>
                  <Typography variant="h5" className={classes.boldText}>
                    {details.name}
                  </Typography>
                  <Typography variant="h5" className={classes.boldText}>
                    {details.secondaryName}
                  </Typography>
                </div>
                <div className={classes.imageContainer}>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/animals/${
                      details.name.split(" ")[0]
                    }.png`}
                    loading="lazy"
                    alt={details.name}
                    className={classes.image}
                  ></img>
                </div>
                <Typography variant="body1" sx={{ margin: "30px 0px" }}>
                  {details.description}
                </Typography>
                <Typography variant="h6">Strengths</Typography>
                <div className={classes.strengths}>
                  {details.strengths.map((strength) => (
                    <Typography
                      key={strength}
                      variant="body1"
                      sx={{ marginRight: "30px" }}
                    >
                      {strength}
                    </Typography>
                  ))}
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </CustomGrid>
  );
};

export default AnimalsScene;
